<div class="spinnerContainer">
  <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
  <span class="sr-only">{{globals?.i18n.application.message.loading}}</span>
</div>
